import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './FilterProducts.css'
import Filter from '../../global/filter/Filter.jsx'
import FilterDataDisplay from './FilterDataDisplay.jsx'

/**
 * FilterProducts - Page Component
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class FilterProducts extends Component {
  /**
   * Prop Types
   *
   * @type {{filterOnFields, products: shim, setSliderData: shim}}
   */
  static propTypes = {
    filterOnFields: PropTypes.arrayOf(PropTypes.string),
    products: PropTypes.object,
    openModalPopup: PropTypes.func,
    setSliderData: PropTypes.func
  }

  /**
   * State
   *
   * @type {{filteredList: Array}}
   */
  state = {
    filteredList: this.props.products
  }

  /**
   * Filter Example Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props)

    this.setFilteredList = this.setFilteredList.bind(this)
  }

  /**
   * Set filtered list
   *
   * @param filteredList
   */
  setFilteredList(filteredList) {
    this.setState({
      filteredList: filteredList
    })
  }

  /**
   * Render
   *
   * @returns {XML}
   */
  render() {
    const { filterOnFields, products, openModalPopup, setSliderData } = this.props
    const { filteredList } = this.state

    return (
      <section className="FilterProducts">
        <Filter
          categoriesList={filterOnFields}
          list={products}
          setFilteredList={this.setFilteredList}
          setSliderData={setSliderData}
        />
        <FilterDataDisplay
          cream={filteredList.cream}
          organic={filteredList.organic}
          natural={filteredList.natural}
          pops={filteredList.pops}
          openModalPopup={openModalPopup}
        />
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/page/filterProducts/FilterProducts.jsx